const dayjs = require('dayjs')

/**
 *  Parse date format from ELIG3/ELIG5 files into a more sane appropriation
 *
 *  @param {String} date The date to transform
 *  @returns {String} A date string in format YYYY-MM-DD
 */
const parseDate = date => {
  let trimmed = date.trim()
  if (!trimmed) return date
  return dayjs(
    trimmed.substring(0, 1) === '1'
      ? '20' + trimmed.substring(1, trimmed.length)
      : '19' + trimmed.substring(1, trimmed.length)
  ).format('YYYY-MM-DD')
}

/**
 *  Make date format for ELIG3/ELIG5 files into a more insane appropriation
 *
 *  @param {String} date The date to transform
 *  @returns {String} A date string in format CYYMMDD
 */
const makeDate = date => {
  let prefix = Number(date.substring(0, 2)) - 19
  return prefix + dayjs(date).format('YYMMDD')
}

module.exports = {
  parseDate,
  makeDate
}
